export default __webpack_public_path__ + "static/hero.light-dc9a0bf33261f1444ab4d9dc6cd90dfdc8cea921cb3ff59d66ea525c89dd7f1e.png";